export default __webpack_public_path__ + "alberta-internal-data.0a66a66fa22fffdee5f8.svg";